import styled, { css } from 'styled-components'
import { limitLines } from 'src/styles'
import { MediaCardProps } from './mediaCard.types'

export const MediaImage = styled.div`
  width: 4.5rem;
  height: 4.5rem;

  img {
    width: 4.5rem;
    height: 4.5rem;
    object-fit: cover;
  }
`

MediaImage.displayName = 'MediaImage'

export const MediaContent = styled.div`
  column-gap: var(--spacer-3);
`

MediaContent.displayName = 'MediaContent'

export const MediaInfo = styled.div`
  column-gap: var(--spacer-3);

  span {
    ${limitLines(2)}
  }
`

MediaInfo.displayName = 'MediaInfo'

export const MediaDetails = styled.div`
  span:not(:last-child) {
    &::after {
      content: '-';
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-left: var(--spacer-1);
      padding-right: var(--spacer-1);
    }
  }
`

MediaDetails.displayName = 'MediaDetails'

type WrapperProps = {
  orientation?: MediaCardProps['orientation']
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ orientation }) => css`
    max-width: ${orientation === 'vertical' ? '17rem' : '20.25rem'};
    flex-direction: ${orientation === 'vertical' ? 'column' : 'row'};
    height: ${orientation === 'vertical' ? 'auto' : '4.5rem'};

    ${MediaImage} {
      width: ${orientation === 'vertical' ? '100%' : '4.5rem'};

      img {
        width: ${orientation === 'vertical' ? '100%' : '4.5rem'};
      }
    }

    ${MediaContent} {
      width: ${orientation === 'vertical' ? 'auto' : '15.5rem'};
      height: ${orientation === 'vertical' ? 'auto' : '4.5rem'};
      padding: ${orientation === 'vertical' ? 'var(--spacer-2) var(--spacer-3)' : 'inherit'};
    }

    ${MediaInfo} {
      span {
        ${limitLines(orientation === 'vertical' ? 1 : 2)}
      }
    }
  `}
`

Wrapper.displayName = 'Wrapper'

export const MediaName = styled.span`
  word-break: break-word;
`

MediaName.displayName = 'MediaName'
